import axiosClient from "@libs/client"

export const getAuthenticatedUser = async () => {
  const response = await axiosClient.get(`/api/auth/user`)
  return response.data
}

export const login = async ({ email, password }) => {
  const response = await axiosClient.post(`/api/auth/login`, {
    email,
    password,
  })
  return response.data
}

export const register = async (formData) => {
  const response = await axiosClient.post(`/api/auth/register`, formData)
  return response.data
}

export const passwordReset = async ({ email }) => {
  const response = await axiosClient.post(`/api/auth/password/reset`, {
    email,
  })
  return response.data
}

export const passwordChange = async ({
  token,
  email,
  password,
  confirmPassword,
}) => {
  const response = await axiosClient.post(`/api/auth/password/change`, {
    token,
    email,
    password,
    password_confirmation: confirmPassword,
  })
  return response.data
}

export const verifyEmail = async ({ otp, email }) => {
  const response = await axiosClient.post(`/api/auth/verify/email`, {
    otp,
    email,
  })
  return response.data
}

export const resendEmailVerification = async ({ email }) => {
  const response = await axiosClient.post(`/api/auth/verify/email/resend`, {
    email,
  })
  return response.data
}

export const initiateSocialLogin = (provider) => {
  // Get the base URL for the backend
  const baseURL = process.env.API_BASE_URL || ""
  // Redirect the browser to the social auth endpoint
  window.location.href = `${baseURL}/api/auth/social/${provider}/redirect`
}
